import { DataTableColumnDef } from "@/components/molecules";
import { FavouriteLocationsTableData } from "./types";

export const favouriteLocationsColumns: DataTableColumnDef<FavouriteLocationsTableData>[] = [
  {
    accessorKey: "locationName",
    header: "Location Name",
    id: "rm_label",
    cell: (props) => props.row.original.locationName,
    size: 280,
  },
  {
    accessorKey: "category",
    header: "Category",
    id: "category",
    cell: (props) => props.row.original.category,
    size: 150,
    enableSorting: false,
  },
  {
    accessorKey: "address",
    header: "Address",
    id: "address",
    cell: (props) => props.row.original.address,
    size: 654,
  },
  {
    accessorKey: "action",
    header: "Action",
    id: "action",
    cell: (props) => props.row.original.action,
    size: 80,
    enableSorting: false,
  },
];
